import React from 'react';

import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ searchQuery, onSearchChange, onSearch }) => {
  const handleSubmit = (e) => {
    e?.preventDefault();
    onSearch();
  };

  return (
    <form onSubmit={handleSubmit} className="bg-card rounded-lg border border-border p-4">
      <div className="flex gap-3">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by name, expertise, or keywords..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
        <Button
          type="submit"
          variant="default"
          iconName="Search"
          iconPosition="left"
        >
          Search
        </Button>
      </div>
    </form>
  );
};

export default SearchBar;